import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const ReviewHouseholdChangeRequestMutation = graphql.persisted(
  "ReviewHouseholdChangeRequest",
  graphql(`
    mutation ReviewHouseholdChangeRequest(
      $requestId: ID!
      $decisions: [HouseholdChangeDecisionInput!]!
      $adminNote: String
    ) {
      reviewHouseholdChangeRequest(input: {
        requestId: $requestId
        decisions: $decisions
        adminNote: $adminNote
      }) {
        changeRequest { id state acceptedCount }
        family {
          id
          emergencyContacts { name phone relationship }
          authorizedPickup { name phone relationship }
          churchAffiliation { churchName pastorName churchEmail }
          address { street street2 city state zip country }
        }
        userErrors { message path }
      }
    }
  `)
);

export { ReviewHouseholdChangeRequestMutation };

export function useReviewHouseholdChangeRequest() {
  return useMutation(ReviewHouseholdChangeRequestMutation);
}
